module.exports = __webpack_public_path__ + "img/forward.c2e30b48.png";